import React from 'react';
import { Link } from 'react-router-dom';
import LazyImage from '../../components/LazyImage';

interface BlogPostCardProps {
  image: string;
  title: string;
  description: string;
  author: string;
  authorImage: string;
  date: string;
  link?: string;
}

const BlogPostCard: React.FC<BlogPostCardProps> = ({
  image,
  title,
  description,
  author,
  authorImage,
  date,
  link = '#'
}) => {
  return (
    <Link 
      to={link}
      className="group block bg-white rounded-[10px] overflow-hidden transition-all duration-300 cursor-pointer relative w-full transform hover:scale-[1.02] hover:-translate-y-1"
      style={{
        boxShadow: '0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0px 8px 12px -4px #10182812, 0px 20px 24px -8px #10182820';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814';
      }}
    >
      {/* Featured Image */}
      <div className="py-6 px-6">
        <div className="relative w-full overflow-hidden rounded-[5px]">
          <LazyImage 
            src={image}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
          />
        </div>
      </div>
      
      {/* Content */}
      <div className="px-6 pb-6 flex flex-col gap-4">
        {/* Title with Arrow */}
        <div className="flex items-start justify-between gap-4">
          <h2 className="text-[22px] font-[700] leading-[32px] text-[#101828] flex-1 transition-colors duration-300 group-hover:text-[#192842]">
            {title}
          </h2>
          <img 
            src="/images/Arrow.webp"
            alt="Arrow"
            className="w-6 h-7 flex-shrink-0 transition-transform duration-300 group-hover:translate-x-1"
          />
        </div>
        
        {/* Description */}
        <p className="text-[16px] font-[400] leading-[24px] text-[#667085]">
          {description}
        </p>
        
        {/* Author & Date */}
        <div className="flex items-center gap-4 mt-4">
          <img 
            src={authorImage}
            alt={author}
            className="w-12 h-12 rounded-full object-cover bg-[#1A2A44]"
          />
          <div>
            <p className="text-[14px] font-[500] leading-[20px] text-[#101828]">{author}</p>
            <p className="text-[14px] font-[400] leading-[20px] text-[#667085]">{date}</p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogPostCard;

